import { TableRow } from "../../interfaces/TableRow"

interface AlvoAPI {
  alvoId?: string;
  alvo?: string;
  [key: string]: any;
}

interface AlvoFormatado {
  id: string;
  nome: string;
}

type Dado = {
  componente: TableRow["componente"];
  utilizacao: TableRow["utilizacao"];
  dose: TableRow["dose"];
  alvo: TableRow["alvo"];
  planoOperacionalOperacaoComponenteId: TableRow["planoOperacionalOperacaoComponenteId"];
};

type RowComDados = TableRow & { dados: Dado[] };

export function agruparPorSequencia(rows: TableRow[] = []): RowComDados[] {
  const map: Record<number, RowComDados> = {};

  for (const r of rows) {
    const seq = r.sequencia ?? 0;

    if (!map[seq]) {
      map[seq] = {
        ...r,
        dados: [],
      };
    }

    map[seq].dados.push({
      componente: r.componente,
      utilizacao: r.utilizacao,
      dose: r.dose,
      alvo: r.alvo,
      planoOperacionalOperacaoComponenteId: r.planoOperacionalOperacaoComponenteId
    });
  }

  const result = Object.values(map).sort((a, b) => (a.sequencia ?? 0) - (b.sequencia ?? 0));

  return result;
}


export function mapAlvosToIdNome(alvos: AlvoAPI[] | undefined): AlvoFormatado {
  if (!alvos || alvos.length === 0) {
    return { id: "", nome: "" };
  }

  const mapKeys: Record<string, keyof AlvoFormatado> = {
    alvoId: "id",
    alvo: "nome",
  };

  return alvos.reduce((acc, obj) => {
    for (const [key, value] of Object.entries(obj)) {
      const newKey = mapKeys[key];
      if (newKey) {
        acc[newKey] = acc[newKey]
          ? `${acc[newKey]}, ${value}`
          : String(value);
      }
    }
    return acc;
  }, { id: "", nome: "" } as AlvoFormatado);
}

export function slugify(str: string, separator = "-"): string {
  if (!str) return "";

  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, separator)
    .replace(new RegExp(`${separator}+`, "g"), separator)
    .toLowerCase();
}

export function normalizeData(data: any) {
  return data.map((item: any) => {
    const text = item.text ?? item.Text ?? item.label ?? item.Value ?? item.value ?? "";
    const value = item.value ?? item.Value ?? item.id ?? item.text ?? "";
    
    return { text, value };
  });
}

export function validateFieldRequired(
  rows: TableRow[],
  index: number,
  form: any,
  record: TableRow
): boolean {

  const hasDuplicate = rows.some((row, i) => {
    if (i === index) return false;

    return (
      row.sequencia === record.sequencia &&
      row.operacao?.value === record.operacao?.value &&
      row.referencia === record.referencia &&
      row.carencia === record.carencia
    );
  });

  if (!hasDuplicate) {
    form.setFields([
      {
        name: ["itens", index, "componente"],
        errors: []
      }
    ]);
  }

  return hasDuplicate;
}

export function closeTabbarItemUtil(
  idLabel: string,
  newList: any[],
  setNewList: (list: any[]) => void,
  setId: (id: string) => void,
  setLabel: (label: string) => void,
  handleClose: () => void
) {
  const labels = newList?.filter((item: any) => item.id !== idLabel);
  if (!labels) return;

  if (labels.length === 0) {
    handleClose();
  }

  setNewList(labels);

  if (labels.length > 0) {
    setId(labels[0].id);
    setLabel(labels[0].id);
  } else {
    setId("");
    setLabel("");
  }
}

